import { NavLink } from 'react-router-dom';
import { MONEY, PAGE } from '@kioskgaming/ui';

const tabClass = ({ isActive }: { isActive: boolean }) =>
  `rounded-lg px-3 py-2 text-sm font-semibold ${isActive ? 'bg-emerald-600 text-white' : 'border border-stone-200 bg-white text-stone-700 hover:bg-stone-50'}`;

/** Counter deposits and redemptions are one "Cash transactions" page with two tabs (decision D6). */
export default function CashTransactionsTabs() {
  return (
    <div className="mb-4">
      <h1 className="text-xl font-bold tracking-tight text-stone-900 sm:text-2xl">{PAGE.cashTransactions}</h1>
      <nav aria-label={PAGE.cashTransactions} className="mt-3 flex flex-wrap gap-2">
        <NavLink to="/cash-settlement/deposits" className={tabClass}>{MONEY.counterDeposits}</NavLink>
        <NavLink to="/cash-settlement/redemptions" className={tabClass}>{MONEY.counterRedemptions}</NavLink>
      </nav>
    </div>
  );
}
